import { IRoute, RouteKey } from "./shared";

// Pages
import Home from 'pages/Home';
import { ListPost, CreatePost, EditPost } from 'pages/Post';
import { CreateContentType, EditContentType, ListContentType } from 'pages/ContentType';
import { CreateMenu, EditMenu, ListMenu } from 'pages/Menu';
import { ListRole } from 'pages/Role';
import ThemeSettings from 'pages/ThemeSettings';
import { Login, Verify, ClarificationText, UndertakingText, CookiePolicy } from "pages/Identity";
import { ListCategory } from 'pages/Category';
import { ListLayout, CreateLayout, EditLayout } from 'pages/Layout';
import { ListUser } from 'pages/User';
import { CreateSpecification, ListSpecifications, ListSpecificationTypes } from "pages/Specification";
import { CreatePlace, EditPlace, ListPlace } from "pages/Place";
import { CreateActivityType, EditActivityType, ListActivityType } from "pages/ActivityType";
import { CreateActivityGroup, EditActivityGroup, ListActivityGroup } from "pages/ActivityGroup";
import { CreateActivityCommunity, EditActivityCommunity, ListActivityCommunity } from "pages/ActivityCommunity";
import { CreateArtist, EditArtist, ListArtist } from "pages/Artist";
import { CreateActivity, EditActivity, ListActivity } from "pages/Activity";
import { CreateArtistRole, EditArtistRole, ListArtistRole } from "pages/ArtistRole";

// Modals
import { PropertiesModal, CategoryModal, BucketModal, UserModal, RoleModal, SpecificationModal, SpecificationTypeModal } from 'components/customs/Modals';
import LocalDataWizardModal from 'components/customs/LocalDataWizard/LocalDataWizardModal';
import CustomServiceWizardModal from 'components/customs/CustomServiceWizard/CustomServiceWizardModal';
import ActivityVariantModal from "components/customs/Modals/ActivityVariantModal";
import FeaturedActivities from "pages/Activity/FeaturedActivities";

export const ROUTES: IRoute[] = [{
    exact: true,
    path: "/",
    component: Home
},
{
    exact: true,
    path: "/categories/:contentTypeId",
    component: ListCategory,
    role: RouteKey.ContentTypes
},
{
    exact: true,
    path: "/posts/:contentTypeId",
    component: ListPost,
    role: RouteKey.ContentTypes
},
{
    exact: true,
    path: "/post/:contentTypeId/create",
    component: CreatePost,
    role: RouteKey.ContentTypes
},
{
    exact: true,
    path: "/post/:contentTypeId/edit",
    component: EditPost,
    role: RouteKey.ContentTypes
},
{
    exact: true,
    path: "/content-types",
    component: ListContentType,
    role: RouteKey.ContentTypeManagement
},
{
    exact: true,
    path: "/content-type/create",
    component: CreateContentType,
    role: RouteKey.ContentTypeManagement
},
{
    exact: true,
    path: "/content-type/edit/:contentTypeId",
    component: EditContentType,
    role: RouteKey.ContentTypeManagement
},
{
    exact: true,
    path: "/specifications",
    component: ListSpecifications,
    role: RouteKey.ContentTypeManagement
},
{
    exact: true,
    path: "/specification/create",
    component: CreateSpecification,
    role: RouteKey.ContentTypeManagement
},
{
    exact: true,
    path: "/specification-types",
    component: ListSpecificationTypes,
    role: RouteKey.ContentTypeManagement
},
{
    exact: true,
    path: "/layouts",
    component: ListLayout,
    role: RouteKey.Layout
},
{
    exact: true,
    path: "/layout/create",
    component: CreateLayout,
    role: RouteKey.Layout
},
{
    exact: true,
    path: "/layout/edit/:layoutId",
    component: EditLayout,
    role: RouteKey.Layout
},
{
    exact: true,
    path: "/menus",
    component: ListMenu,
    role: RouteKey.Menu
},
{
    exact: true,
    path: "/menu/create",
    component: CreateMenu,
    role: RouteKey.Menu
},
{
    exact: true,
    path: "/menu/edit/:menuId",
    component: EditMenu,
    role: RouteKey.Menu
},
{
    exact: true,
    path: "/places",
    component: ListPlace,
    role: RouteKey.Place
},
{
    exact: true,
    path: "/place/create",
    component: CreatePlace,
    role: RouteKey.Place
},
{
    exact: true,
    path: "/place/edit/:placeId",
    component: EditPlace,
    role: RouteKey.Place
},
{
    exact: true,
    path: "/activity-types",
    component: ListActivityType,
    role: RouteKey.ActivityType
},
{
    exact: true,
    path: "/activity-type/create",
    component: CreateActivityType,
    role: RouteKey.ActivityType
},
{
    exact: true,
    path: "/activity-type/edit/:activityTypeId",
    component: EditActivityType,
    role: RouteKey.ActivityType
},
{
    exact: true,
    path: "/activity-groups",
    component: ListActivityGroup,
    role: RouteKey.ActivityGroup
},
{
    exact: true,
    path: "/activity-group/create",
    component: CreateActivityGroup,
    role: RouteKey.ActivityGroup
},
{
    exact: true,
    path: "/activity-group/edit/:activityGroupId",
    component: EditActivityGroup,
    role: RouteKey.ActivityGroup
},
{
    exact: true,
    path: "/activity-communities",
    component: ListActivityCommunity,
    role: RouteKey.ActivityCommunity
},
{
    exact: true,
    path: "/activity-community/create",
    component: CreateActivityCommunity,
    role: RouteKey.ActivityCommunity
},
{
    exact: true,
    path: "/activity-community/edit/:activityCommunityId",
    component: EditActivityCommunity,
    role: RouteKey.ActivityCommunity
},
{
    exact: true,
    path: "/artist-roles",
    component: ListArtistRole,
    role: RouteKey.ArtistRole
},
{
    exact: true,
    path: "/artist-role/create",
    component: CreateArtistRole,
    role: RouteKey.ArtistRole
},
{
    exact: true,
    path: "/artist-role/edit/:artistRoleId",
    component: EditArtistRole,
    role: RouteKey.ArtistRole
},
{
    exact: true,
    path: "/artists",
    component: ListArtist,
    role: RouteKey.Artist
},
{
    exact: true,
    path: "/artist/create",
    component: CreateArtist,
    role: RouteKey.Artist
},
{
    exact: true,
    path: "/artist/edit/:artistId",
    component: EditArtist,
    role: RouteKey.Artist
},
{
    exact: true,
    path: "/activities",
    component: ListActivity,
    role: RouteKey.Activity
},
{
    exact: true,
    path: "/featured-activities",
    component: FeaturedActivities,
    role: RouteKey.FeaturedActivities
},
{
    exact: true,
    path: "/activity/create",
    component: CreateActivity,
    role: RouteKey.Activity
},
{
    exact: true,
    path: "/activity/edit/:activityId",
    component: EditActivity,
    role: RouteKey.Activity
},
{
    exact: true,
    path: "/roles",
    component: ListRole,
    role: RouteKey.Roles
},
{
    exact: true,
    path: "/user",
    component: ListUser,
    role: RouteKey.Users
},
{
    exact: true,
    path: "/theme-settings",
    component: ThemeSettings,
    role: RouteKey.ThemeSettings
},
{
    exact: true,
    path: "/login",
    component: Login,
    public: true
},
{
    exact: true,
    path: "/verify",
    component: Verify,
    public: true
},
{
    exact: true,
    path: "/clarification-text",
    component: ClarificationText,
    public: true
},
{
    exact: true,
    path: "/cookie-policy",
    component: CookiePolicy,
    public: true
},
{
    exact: true,
    path: "/undertaking-text",
    component: UndertakingText,
    public: true
},
{
    exact: false,
    path: "/",
    component: PropertiesModal
},
{
    exact: false,
    path: "/",
    component: PropertiesModal
},
{
    exact: false,
    path: "/",
    component: CategoryModal
},
{
    exact: false,
    path: "/",
    component: UserModal
},
{
    exact: false,
    path: "/",
    component: ActivityVariantModal
},
{
    exact: false,
    path: "/",
    component: CustomServiceWizardModal
},
{
    exact: false,
    path: "/",
    component: LocalDataWizardModal
},
{
    exact: false,
    path: "/",
    component: BucketModal
},
{
    exact: false,
    path: "/",
    component: RoleModal
},
{
    exact: false,
    path: "/",
    component: SpecificationModal
},
{
    exact: false,
    path: "/",
    component: SpecificationTypeModal
}];
